module.exports = __webpack_public_path__ + "img/partner_31.d9ef14c3.png";